import { useEdgeComputeConfigured } from '@/react/edge/useEdgeComputeConfigured';

import { useWizardSteps } from '@@/Stepper/useWizardSteps';
import { PageHeader } from '@@/PageHeader';
import { TextTip } from '@@/Tip/TextTip';
import { Widget, WidgetBody, Loading } from '@@/Widget';
import { Link } from '@@/Link';

import {
  WizardStep,
  WizardProvider,
  WizardMode,
} from '../wizard/WizardContext';
import { ArtifactsStep } from '../wizard/steps/ArtifactsStep';
import { SourceSelectStep } from '../wizard/steps/SourceSelectStep';
import { ReviewStep } from '../wizard/steps/ReviewStep';
import { ArtifactConfigStep } from '../wizard/steps/ArtifactConfigStep/ArtifactConfigStep';

import { CreateForm } from './CreateForm';

const steps: WizardStep[] = [
  SourceSelectStep,
  ArtifactsStep,
  ArtifactConfigStep,
  ReviewStep,
];

export function CreateView() {
  return (
    <div className="form-horizontal pb-20">
      <PageHeader
        title="Create Workflow"
        breadcrumbs={[
          { link: '.^', label: 'GitOps Workflows' },
          { label: 'Create Workflow' },
        ]}
      />

      <div className="row">
        <div className="col-sm-12">
          <CreateViewContent />
        </div>
      </div>
    </div>
  );
}

function CreateViewContent() {
  const context = useWizardSteps<WizardStep>({ steps });
  const edgeComputeConfiguredQuery = useEdgeComputeConfigured();

  if (edgeComputeConfiguredQuery.isLoading) {
    return <Loading />;
  }

  if (!edgeComputeConfiguredQuery.isSuccess) {
    return null;
  }

  if (!edgeComputeConfiguredQuery.data) {
    return <EdgeComputeDisabledNotice />;
  }

  return (
    <WizardProvider context={{ ...context, mode: WizardMode.Create }}>
      <CreateForm steps={steps} />
    </WizardProvider>
  );
}

function EdgeComputeDisabledNotice() {
  return (
    <Widget>
      <WidgetBody>
        <TextTip color="orange">
          Workflows deploy to Edge groups, so Edge Compute features must be
          enabled to create one. Turn them on{' '}
          <Link
            to="portainer.settings.edgeCompute"
            data-cy="workflow-create-edge-disabled-settings-link"
          >
            here
          </Link>{' '}
          and have the Portainer API server URL and tunnel server address
          properly configured.
        </TextTip>
      </WidgetBody>
    </Widget>
  );
}
